import React, { useState, useEffect } from 'react'
import { StoredItemsProps, KnowledgeBaseItem } from '../../interfaces'
import { SearchBar } from './SearchBar'
import { ItemCard } from './ItemCard'
import styles from './styles.module.scss'

export const StoredItems: React.FC<StoredItemsProps> = ({ items, onView, onDownload, onDelete }) => {
    const [searchText, setSearchText] = useState('')
    const [sourceFilter, setSourceFilter] = useState<'all' | 'supreme-court' | 'financial-ombudsman'>('all')
    const [filteredItems, setFilteredItems] = useState<KnowledgeBaseItem[]>(items)

    useEffect(() => {
        let filtered = Array.from(new Set(items.map((item) => JSON.stringify(item)))).map((item) => JSON.parse(item))

        // Filter by source
        if (sourceFilter !== 'all') {
            filtered = filtered.filter((item) => item.source === sourceFilter)
        }

        // Filter by search text
        if (searchText.trim()) {
            filtered = filtered.filter((item) => item.title.toLowerCase().includes(searchText.toLowerCase()))
        }
        // Sort by timestamp (most recent first)
        console.log('filtered', filtered)

        if (filtered.length > 0) {
            filtered.sort((a, b) => {
                const dateA = new Date(a.created_at)
                const dateB = new Date(b.created_at)
                return dateB.getTime() - dateA.getTime()
            })
        }

        setFilteredItems(filtered)
    }, [searchText, sourceFilter, items])

    const handleSearchChange = (text: string) => {
        setSearchText(text)
    }

    const getSourceLabel = (source: string) => {
        switch (source) {
            case 'supreme-court':
                return 'Supreme Court'
            case 'financial-ombudsman':
                return 'Financial Ombudsman'
            default:
                return 'All Sources'
        }
    }

    const getItemCountBySource = (source: 'all' | 'supreme-court' | 'financial-ombudsman') => {
        if (source === 'all') return items.length
        return items.filter((item) => item.source === source).length
    }

    return (
        <div className={styles.storedItemsContainer}>
            <div className={styles.itemsHeader}>
                <h3>Stored Knowledge Base Items ({filteredItems.length})</h3>
                <div className={styles.controls}>
                    <div className={styles.sourceFilter}>
                        <label>Filter by source:</label>
                        <select
                            value={sourceFilter}
                            onChange={(e) => setSourceFilter(e.target.value as any)}
                            className={styles.sourceSelect}
                        >
                            <option value="all">All Sources ({getItemCountBySource('all')})</option>
                            <option value="supreme-court">
                                Supreme Court ({getItemCountBySource('supreme-court')})
                            </option>
                            <option value="financial-ombudsman">
                                Financial Ombudsman ({getItemCountBySource('financial-ombudsman')})
                            </option>
                        </select>
                    </div>
                    <SearchBar searchText={searchText} onSearchChange={handleSearchChange} />
                </div>
            </div>

            <div className={styles.itemsGrid}>
                {filteredItems.map((item) => (
                    <ItemCard key={item.id} item={item} onView={onView} onDownload={onDownload} onDelete={onDelete} />
                ))}
            </div>

            {filteredItems.length === 0 && (
                <div className={styles.emptyState}>
                    <p>
                        {searchText || sourceFilter !== 'all'
                            ? 'No knowledge base items found matching your filters.'
                            : 'No knowledge base items found.'}
                    </p>
                </div>
            )}
        </div>
    )
}
